<template>
	<div style="width: 100%">

    <h1>{{title}}</h1>

    <div v-show="!launch">
        <p>{{desc}}</p>
        <vue-dropzone
            v-on:vdropzone-thumbnail="thumbnail"
            v-on:vdropzone-sending-multiple="sendingEvent"
            v-on:vdropzone-success-multiple="successMultiple"
            v-on:vdropzone-file-added="add"
            v-on:vdropzone-total-upload-progress="progress"
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions">
        </vue-dropzone>
        <p></p>
        <b-button
            variant="success"
            v-on:click="start"
            >Démarrer</b-button
        >

        <span v-if="nb_files > 0" class="marge"
            >Nombre de fichiers : {{ nb_files }} - Taille totale :
            {{ size_files }} mo</span
        >
    </div>
    <p></p>
    <div v-if="launch == 1">
        <p>Téléchargement en cours</p>
        <b-progress :value="counter" animated></b-progress>
    </div>
    <div v-if="launch == 2">
        <p>{{response}}</p>
		<div class="center_spinner">
			<fade-loader></fade-loader>
		</div>
    </div>
    <div v-if="launch == 3">
		<div v-if="status == 'ok'">
			{{response_sucess}}
		</div>
		<div v-else>
			{{response_error}} : {{error}}
		</div>
    </div>
    <p></p>
    <b-table
        v-if="nb_files > 0"
        striped
        hover
        :items="files"
        :fields="fields">
        <template v-slot:cell(del)="data">
            <b-button
                v-on:click="del_file(data.value, data.value.name)"
                ><i class="fas fa-trash-alt"></i
            ></b-button>
        </template>
    </b-table>
	</div>
</template>

<script>
	import vue2Dropzone from "vue2-dropzone";
	import "vue2-dropzone/dist/vue2Dropzone.min.css";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	var clone = require("clone");

	import store from "../store";
	import projects from "../services/projects.js";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import scenario from "../services/scenario";

	export default {
		name: "form_treatment",
		components: {
			vueDropzone: vue2Dropzone,
			FadeLoader: FadeLoader,
			treatment: treatment,
		},
		data: function () {
			return {
				first: false,
				dropzoneOptions: {
					url: `${process.env.VUE_APP_SAAS_BACK}` + "/treatments",
					dictDefaultMessage: "Télécharger les fichiers",
					autoProcessQueue: false,
					uploadMultiple: true,
					maxFiles: 10000,
					parallelUploads: 10000,
					previewTemplate: this.template(),
					timeout: 3600000,
					maxFilesize: 10000,
					inter: 0,
				},

				documentation: null,
				projects_options: [
					{ value: null, text: "Sélectionner un projet" },
				],
				launch: 0,
				counter: 0,
				fields: [
					{
						key: "name",
						label: "Nom",
					},
					{
						key: "size",
						label: "Taille",
					},
					{
						key: "del",
						label: "",
					},
				],
				files: [],
				nb_files: 0,
                size_files: 0,
                
                title: "",
                desc: "",
				response: "",
				response_sucess: "",
				response_error: "",
				
				id_treatment: 0,
				status: "",
				error: ""
			};
		},
		methods: {

			getTreatment: async function () {
				try {
					this.result = await treatments.get(this.id_treatment, this.form.key);
					console.log(this.result)
					this.project = this.result.project.libelle;
					this.project_data = this.result.project;
					if (this.result.project.details)
						this.list_actions_result = this.result.project.details.actions_result;
					this.date_start = this.result.treatment.dateheure_debut;
					this.date_end = this.result.treatment.dateheure_fin;
					this.status = this.result.treatment.resultat;
					if (this.status == "na") this.status = null;
					this.user = this.result.user;
					var csv_file = null;

					if (this.status) {
						clearInterval(this.inter);

						this.launch = 3;
						this.status = this.result.treatment.resultat;
						if (this.status == "ko")
							this.error = this.result.treatment.details.error
						console.log("final result")
					}
				} catch (error) {
					console.log(error);
				}
			},
			template: function () {
				return `<div></div>`;
			},
			thumbnail: function (file, dataUrl) {
				var j, len, ref, thumbnailElement;
				if (file.previewElement) {
					file.previewElement.classList.remove("dz-file-preview");
					ref = file.previewElement.querySelectorAll(
						"[data-dz-thumbnail-bg]"
					);
					for (j = 0, len = ref.length; j < len; j++) {
						thumbnailElement = ref[j];
						thumbnailElement.alt = file.name;
						thumbnailElement.style.backgroundImage =
							'url("' + dataUrl + '")';
					}
					return setTimeout(
						(function (_this) {
							return function () {
								return file.previewElement.classList.add(
									"dz-image-preview"
								);
							};
						})(this),
						1
					);
				}
			},
			start: async function (_tags, _project, _type) {
				var self = this;

				this.type = "import";
				if (_type) this.type = _type;

				this.launch = 1;
				if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
					this.$refs.myVueDropzone.processQueue();
				} else {
					treatments
						.create(
                            this.form.project_id,
							null,
                            null,
                            null,
                            null,
                            null,
                            null
						)
						.then((res) => {
							self.launch = 2;
							self.id_treatment = res.treatment.uid;
							self.inter = setInterval(function () {
								self.getTreatment();
							}, 5000);
						})
						.catch((err) => {
							console.log("error : " + err);
							this.$notify({
								group: "info",
								title: err.response.data.msg,
								type: "error",
							});
						});
				}
			},
			sendingEvent(file, xhr, formData) {
                formData.set("project", this.form.project_id);
			},
			successMultiple(files, response) {
				console.log("successMultiple")
				
				var self = this;

				this.files = [];
				this.nb_files = 0;
				this.size_files = 0;

				this.launch = 2;

				this.id_treatment = response.treatment.uid;

				this.inter = setInterval(function () {
					self.getTreatment();
				}, 5000);
			},
			add(file) {
				this.files.push({
					name: file.name,
					size: (file.size / 1000000).toFixed(3) + " mo",
					del: file.upload.uuid,
				});
				this.nb_files++;
				this.size_files = (
					parseFloat(this.size_files) +
					parseFloat(file.size / 1000000)
				).toFixed(3);
			},
			del_file(uuid) {
				var dropzone_files = this.$refs.myVueDropzone.getQueuedFiles();
				var size = 0;

				for (var i = 0; i < dropzone_files.length; i++) {
					if (dropzone_files[i]["upload"]["uuid"] == uuid) {
						size = dropzone_files[i]["size"];
						this.$refs.myVueDropzone.removeFile(dropzone_files[i]);
					}
				}
				for (var i = 0; i < this.files.length; i++) {
					if (this.files[i].del == uuid) {
						this.nb_files--;
						this.size_files = (
							parseFloat(this.size_files) -
							parseFloat(size / 1000000)
						).toFixed(3);
						this.files.splice(i, 1);
					}
				}
			},
			progress(totaluploadprogress, totalBytes, totalBytesSent) {
				this.counter = totaluploadprogress;
			},
		},
		mounted: async function () {

			var self = this;
            this.resolve = null;
            
            this.form = JSON.parse(process.env.VUE_APP_FORM);
            this.form = this.form[this.$route.params.key];	
            
            this.$refs.myVueDropzone.setOption("headers", {
                key: this.form.key,
                project: this.form.project_id
            });
            
            this.title = this.form.title || "Traitement de fichiers";
            this.desc = this.form.desc || "";
            this.response = this.form.response || "Fichiers envoyés";
            this.response_sucess = this.form.response_sucess || "Fichiers traités avec succès";
            this.response_error = this.form.response_error || "Une erreur s'est produite";
		},
		beforeDestroy: async function () {
			if (this.inter) {
				clearInterval(this.inter);
			}
		}
	};
</script>

<style>
	.description-title {
		font-size: x-large;
		width: 20%;
	}

	.description-body {
		font-size: large;
	}

	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}

	#dropzone .dz-message {
		margin: 0.5em 0;
	}

	#dropzone .dz-preview {
		width: 160px;
		display: inline-block;
	}
	#dropzone .dz-preview .dz-image > div {
		width: inherit;
		height: inherit;
		border-radius: 50%;
		background-size: contain;
	}
	#dropzone .dz-preview .dz-image > img {
		width: 100%;
	}

	#dropzone .dz-preview .dz-details {
		color: rgb(0, 0, 0);
		transition: opacity 0.2s linear;
		text-align: center;
	}
	#dropzone .dz-success-mark,
	.dz-error-mark,
	.dz-remove {
		display: none;
	}

	.dropzone.dz-started .dz-message {
		display: block;
	}
</style>
